import { createLogger } from '../utils/logging';
import {
    refreshToken,
    removeOldToken,
} from '../actions/authentication';
import {
    getSecondsToLogout,
    getUserIdFromToken,
    isValidToken,
} from '../utils/authentication';
import {
    getRefreshTimeoutInSec,
    incrementRefreshAttempts,
    initRefreshTokenTimer,
    clearRefreshAttempts,
    clearRefreshTokenTimer,
    shouldDoCleanup,
    shouldHandleTokenRefreshFailure,
    shouldProcessNewAccessToken,
    shouldRefresh,
} from './authenticationMiddlewareUtils';

const logger = createLogger('Authentication Middleware');

const authenticationMiddleware = (store) => (next) => (action) => {
    const actionType = action.type;
    if (shouldProcessNewAccessToken(actionType)) {
        processNewAccessToken(store, action);
    }
    if (shouldHandleTokenRefreshFailure(actionType)) {
        handleTokenRefreshFailure(store, action);
    }
    if (shouldDoCleanup(actionType)) {
        doCleanup();
    }
    next(action);
};

const processNewAccessToken = (store, action) => {
    const accessToken = action.payload;
    if (accessToken) {
        if (isValidToken(accessToken)) {
            clearRefreshAttempts();
            resetRefreshTokenTimer(store.dispatch, accessToken);
        } else {
            logger.warn('Removing token which is not valid anymore!');
            store.dispatch(removeOldToken());
        }
    }
};

const handleTokenRefreshFailure = (store, action) => {
    if (shouldRefresh()) {
        const accessToken = action.payload;
        resetRefreshTokenTimer(store.dispatch, accessToken);
        logger.debug('Refresh of Access Tokes has been re-planned...');
    } else {
        logger.warn('Refresh of Access Token could not be re-planned, too many failed attempts!');
    }
};

const resetRefreshTokenTimer = (dispatch, accessToken) => {
    const refreshTimeoutInSec = getRefreshTimeoutInSec(getSecondsToLogout(accessToken));
    scheduleRefreshTokenTimer(dispatch, accessToken, refreshTimeoutInSec);
};

const scheduleRefreshTokenTimer = (dispatch, accessToken, refreshTimeoutInSec) => {
    clearRefreshTokenTimer();
    const userId = getUserIdFromToken(accessToken);
    const milisecsToRefreshToken = refreshTimeoutInSec * 1000;
    initRefreshTokenTimer(() => {
        incrementRefreshAttempts();
        dispatch(refreshToken(userId, accessToken));
    }, milisecsToRefreshToken);
};

const doCleanup = () => {
    clearRefreshTokenTimer();
    clearRefreshAttempts();
};

export default authenticationMiddleware;
